import React, { useState } from 'react';
import LoginForm from '../components/LoginForm.tsx';
import JoinTenantForm from '../components/JoinTenantForm.tsx';

interface LoginProps {
  onLoginSuccess: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [showJoinForm, setShowJoinForm] = useState(false);

  const handleSwitchToJoin = () => {
    setShowJoinForm(true);
  };

  const handleSwitchToLogin = () => {
    setShowJoinForm(false);
  };

  const handleJoinSuccess = () => {
    setShowJoinForm(false); // ログインフォームに戻る
  };

  if (showJoinForm) {
    return (
      <JoinTenantForm
        onJoinSuccess={handleJoinSuccess}
        onSwitchToLogin={handleSwitchToLogin}
      />
    );
  }

  return (
    <LoginForm
      onLoginSuccess={onLoginSuccess}
      onSwitchToJoin={handleSwitchToJoin}
    />
  );
};

export default Login;
